import { scriptTag } from '~/utility/scriptTag'

export function useJobHead() {
  const scriptTags = scriptTag({
    gtag: true,
    globalSite: true,
    criteoItem: undefined,
    zendeskTag: true,
    facebookPixelCode: true,
  })

  useHead({
    title: 'メンター講師の募集',
    meta: [],
    script: scriptTags.script,
    noscript: scriptTags.noscript
  })
}
